import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import RoundedButton from './Buttons/RoundedButton';
const PreviousIcon= () => {
    return (
    
    <RoundedButton aria-label='Προηγούμενο' sx={{padding:0, margin:0}} variant="text" color='black' startIcon={<KeyboardArrowLeftIcon fontSize='small'/>}>
  Προηγούμενο
</RoundedButton>)
}
export default PreviousIcon